import { useMutation } from '@tanstack/react-query';

import PromptsService, { RenderPromptDto } from '@/services/PromptsService';

export function useRenderPrompt() {
  const { mutateAsync, isPending } = useMutation({
    mutationFn: (renderPromptDto: RenderPromptDto) =>
      PromptsService.renderPrompt(renderPromptDto),
  });

  return {
    renderPrompt: mutateAsync,
    isLoading: isPending,
  };
}
